<template>
  <div class="Subpage">
    <Bigmenu :NavStatus="Bignav" :Way="1" :ShowBackBtn="true" v-on:cellback="OpenStatus" style="z-index: 2"></Bigmenu>
    <div class="frame" style="z-index: -2"></div>
    <Container2 v-if="!Bignav" :Type="false" :ImgUrl="'b01.png'" :Container="Container"  style="z-index: -6"></Container2>
  </div>
</template>

<script>
import Bigmenu from '@/components/Bigmenu.vue'
import Back from '@/components/Back.vue';
import Container2 from '@/components/Container2.vue';
export default {
  name: 'About',
  data () {
    return {

      Bignav: false,
      Container:{
        video:{
          title:'國人十大癌症 攝護腺癌',
          videosrc:'R06.mp4',
          list:[
            {

              title:'病友分享',
              body:"為一患者罹癌的心路歷程，從被診斷出攝護腺癌，到治療計畫規劃、放射治療、後續的追蹤以及實際治療結果的描述。"

            }

          ]
        },
        text:{
          title:'國人十大癌症 － 攝護腺癌',
          videobtnname:'病友分享',
          videoImg:'R06v.png',
          list:[
            {

              title:'攝護腺癌是什麼？',
              body:"攝護腺是位於膀胱頸出口下的一個錐形腺體組織環繞著尿道，由五個葉及一群腺泡所形成的性腺。攝護腺癌的發生部位，卻在攝護腺外圍離尿道較遠，因而初期沒有什麼症狀，要到癌細胞壓迫到尿道才會有頻尿、排尿困難、有餘尿等症狀。攝護腺癌常見於50歲以上的男性。台灣的罹患率亦因平均壽命增加及篩檢進步而顯著增加。"

            },
            {

              title:'如何治療攝護腺癌？',
              body:"攝護腺癌治療方式，必須考慮以下三種：(1)手術：包含攝護腺及淋巴切除或睪丸摘除。(2)放射治療：包含全骨盆腔照射、攝護腺照射與局部骨轉移照射。(3)荷爾蒙治療。一般而言，切除攝護腺及淋巴手術適合於較早期、年齡較輕及身體狀況可承受開刀者。"

            },
            {

              title:'攝護腺癌放射治療的原因和時機？',
              body:[
                "早期攝護腺癌：可做手術切除、放療、冷凍治療，積極監控或觀察性追蹤。","中期攝護腺癌：放療合併荷爾蒙治療、冷凍治療或手術切除，較少僅做積極監控或觀察性追蹤。在治療效果方面，開刀、放療及冷凍治療並無太大差異，但個別之副作用或併發症不盡相同，選擇治療前應多詢問專家之意見。"
              ]

            },
          ]
        }
      },

    }
  },
  components: {
    Back,Container2,Bigmenu
  },
  methods:{
    OpenStatus(v){
      this.Bignav = v.status
    }
  }
}
</script>
<style lang="scss" scoped>
  .Subpage{
    height: 100%;
    width: 100%;
  }
  .frame {

    position: absolute;
    background-image: url("../../assets/frame.png");
    background-position: center;
    height: 1080px;
    width: 1920px;
  }
</style>
